import { Badge, Box, Flex, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionDto } from "../../../../../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../../../../../common/input/TipTap/TipTap";
import { SELECTION_CRITERION_TYPE_OPTIONS } from "../../utils/publicProcurementOptions";

interface SelectionCriteriaListProps {
  criteria: SelectionCriterionDto[];
}

export const SelectionCriteriaList = ({ criteria }: SelectionCriteriaListProps) => {
  const { t } = useTranslation();

  return (
    <VStack spacing="3" align="stretch">
      {criteria.map((c, index) => {
        const typeOption = SELECTION_CRITERION_TYPE_OPTIONS.find((o) => o.value === c.type);
        return (
          <Box
            key={`${c.type}-${c.name}-${index}`}
            bg="smBackground"
            borderWidth="1px"
            borderColor="smBorder"
            borderRadius="md"
            p="3"
          >
            <Flex gap="2" mb="2" flexWrap="wrap">
              {typeOption && (
                <Badge
                  bg={typeOption.badgeBg}
                  color={typeOption.badgeColor}
                  px="2"
                  py="0.5"
                  borderRadius="md"
                  fontWeight="medium"
                  fontSize="xs"
                  textTransform="none"
                >
                  {t(typeOption.value)}
                </Badge>
              )}
              {c.requiresEvidence && (
                <Badge
                  variant="outline"
                  borderColor="smBorder"
                  color="smMuted"
                  px="2"
                  py="0.5"
                  borderRadius="md"
                  fontWeight="medium"
                  fontSize="xs"
                  textTransform="none"
                >
                  {t("Requires evidence")}
                </Badge>
              )}
            </Flex>
            <Text fontWeight="bold" mb="1">
              {c.name}
            </Text>
            {!isTiptapContentEmpty(c.description) && (
              <Box color="smMuted" fontSize="sm">
                <TipTap
                  content={c.description}
                  editable={false}
                  hasBorder={false}
                  padding="0"
                  maxHeight=""
                />
              </Box>
            )}
          </Box>
        );
      })}
    </VStack>
  );
};
